import { css } from '@emotion/react'

import { mediaQuery } from '~/@common/styles/mediaQuery'
import BarLineChart, { type BarLineChartItem } from '~/@common/ui/BarLineChart/BarLineChart'
import InfoTooltip from '~/@common/ui/InfoTooltip/InfoTooltip'

import SectionHeader from '../SectionHeader'

// 위젯 전용 데이터 타입 (주간 날짜 포함)
export type WeeklyChartData = {
  label: string
  barData: number // 풀이 문제 수
  dotData: number // 정답률 (0–100)
  weekStartDate: string // yyyy.MM.dd
  weekEndDate: string // MM.dd
  id: string
}

// WeeklyChartData → 공통 BarLineChartItem 변환
const toChartItems = (items: WeeklyChartData[]): BarLineChartItem[] =>
  items.map((d) => ({
    label: d.label,
    barValue: d.barData,
    lineValue: d.dotData,
    tooltipTitle: `${d.weekStartDate}~${d.weekEndDate}`,
    id: d.id,
  }))

/**
 * "최근 4주간 푼 문제" — 바+라인 차트
 * 순수 UI 컴포넌트: 변환된 WeeklyChartData[]를 props로 전달받음
 */
const WeeklyChart = ({ data }: { data: WeeklyChartData[] }) => {
  const chartItems = toChartItems(data)

  return (
    <div css={_Style}>
      <SectionHeader title="최근 4주간 푼 문제">
        <InfoTooltip
          title="최근 4주간 학습한 내용을 요약해드려요"
          items={['4주간 푼 문제 수와 정답률을 확인할 수 있습니다.']}
        />
      </SectionHeader>
      <div css={_ChartContainer}>
        <BarLineChart data={chartItems} />
      </div>
    </div>
  )
}

export default WeeklyChart

const _Style = css`
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
`

const _ChartContainer = css`
  flex: 1;
  min-width: 0;
  min-height: 0;
  padding: 20px;
  background: var(--White);
  border-radius: var(--Radius-300);

  ${mediaQuery.underTablet} {
    max-height: 180px;
  }
`
